module.exports = __webpack_public_path__ + "static/media/9.d437f22a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/Artists/01/projects/01/9.jpg
// module id = 400
// module chunks = 0